import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';
import { Link } from 'react-router';
import { focusAreaReviewTypes } from '../../../../config';

const PreReviewSummary = ({ selectedReview }) => {
  if (!selectedReview) return null;

  const fiscalYear =
    selectedReview.fiscalYear && selectedReview.fiscalYear.toString().slice(-2);
  const newFormReviewTypes = ['Special', 'AIAN-DEF Reeval'];

  return selectedReview &&
    (selectedReview.reviewType === 'FA1-FR' ||
      selectedReview.reviewType === 'FA2-CR' ||
      focusAreaReviewTypes.includes(selectedReview.reviewType) ||
      (newFormReviewTypes.includes(selectedReview.reviewType) &&
        selectedReview?.isNewForms)) &&
    selectedReview.fiscalYear >= 2024 ? (
    <Menu.Item
      as={Link}
      to={`/review/fy${fiscalYear}/${selectedReview.reviewId}/pre_review_summary`}
    >
      Pre-Review Summary
    </Menu.Item>
  ) : null;
};

PreReviewSummary.propTypes = {
  selectedReview: PropTypes.object,
};

const mapStateToProps = state => ({
  selectedReview: state.review.selectedReview,
});

export default connect(mapStateToProps)(PreReviewSummary);
